import Vuex from "vuex"
import { getAccountInfo } from "@/api/auth"
import { getComm, getStoreInfo } from "@/api/comm"
import { getClickCollectStores } from "@/api/delivery"
import { Logger } from "@/plugins/logger"
import { resetLocal, getRequestHeaders, getLoginStatus, getDeliveryMethod } from "@/utils/utils"
import { setCommonParam, setCommonReqParam } from "@/plugins/env"
import storage from "@/utils/storage"

export const resetComm = function ($cookies) {
  //  构造假store
  const store = {
    id: -1,
    storeId: -1,
    latitude: 0,
    longitude: 0
  }
  localStorage.setItem("storeInfo", JSON.stringify(store))
  $cookies.set("store", store.storeId)
  window.location.reload()
}

const updateSelStore = async $cookies => {
  try {
    const curSelStore = storage.get("curSelStore")
    // 门店不存在 || 无erpStoreId(自提门店)字段 || 配送模式
    if (!curSelStore || !("erpStoreId" in curSelStore) || getDeliveryMethod() === "homeDelivery") {
      return
    }
    const locale = $cookies.get("superweb-locale") || "zh_HK"
    if (locale === curSelStore._locale) {
      return
    }
    const { data: res } = await getClickCollectStores({ param: JSON.stringify({ erpStoreId: curSelStore.erpStoreId }) })
    const target = (res || []).find(item => item.erpStoreId === curSelStore.erpStoreId)
    if (target) {
      target._locale = locale
      storage.set("curSelStore", target)
    }
  } catch (error) {
    console.log(error)
  }
}

const store = () =>
  new Vuex.Store({
    state: {
      token: "",
      lang: "",
      commonParams: null,
      accountInfo: null,
      storeInfo: null,
      isServerInit: false,
      // 作为服务端部分cookie无法即时更新补充
      resCookies: {
        store: "",
        longitude: "",
        latitude: ""
      },
      domainFlag: null
    },
    mutations: {
      setToken(state, token) {
        state.token = token
      },
      setLang(state, lang) {
        state.lang = lang
      },
      setIsServerInit(state, isServerInit) {
        state.isServerInit = isServerInit
      },
      setCommonParams(state, commonParams) {
        state.commonParams = commonParams
      },
      setResCookies(state, resCookies) {
        state.resCookies = resCookies
      },
      setStoreInfo(state, storeInfo) {
        state.storeInfo = storeInfo
      },
      setAccountInfo(state, accountInfo) {
        state.accountInfo = accountInfo
      },
      setDomainFlag(state, domainFlag) {
        state.domainFlag = domainFlag
      },
      setState(state, { key, value }) {
        state[key] = value
      }
    },
    actions: {
      getCommonParamsSet(store) {
        const { $cookies } = this
        return {
          comm: setCommonParam({ store, $cookies }),
          commonReqParams: setCommonReqParam({ store, $cookies })
        }
      },
      /**
       * 作为走服务端初始化后的数据还原
       * @param {*} store
       */
      async setStorageData(store) {
        const { accountInfo, storeInfo } = store.state
        const commData = await store.dispatch("getCommonParamsSet")
        storage.set("accountInfo", accountInfo, { useBase64: true })
        storage.set("storeInfo", storeInfo)
        storage.set("commData", commData)
      },
      async bootstrapData(store, { req }) {
        try {
          const { $cookies } = this
          const { commit, dispatch, state } = store
          let { commonParams } = state
          const token = $cookies.get("token")
          const curSelStore = storage.get("curSelStore") || {}
          const pickUpStoreId = $cookies.get("pickUpStoreId") || curSelStore.erpStoreId || ""
          const shipmentType = $cookies.get("shipmentType")
          const saleType = $cookies.get("saleType")
          const venderId = $cookies.get("venderId")
          let storeId = $cookies.get("store")
          let accountInfo = storage.get("accountInfo", { useBase64: true }) || null
          let storeInfo = storage.get("storeInfo") || null
          let curSelAddress = storage.get("curSelAddress", { useBase64: true }) || null
          let defaultAddress = null

          if (!commonParams || !commonParams.pickUpStoreId) {
            commonParams = await dispatch("getCommonParams", {
              params: {
                shipmentType,
                pickUpStoreId,
                saleType
              }
            })
          }

          // 初始化构造comm参数
          setCommonParam({ store, $cookies })

          // 初始化部分cookie数据
          if (!venderId) {
            $cookies.set("venderId", commonParams?.venderId)
          }
          if (!pickUpStoreId) {
            $cookies.set("pickUpStoreId", commonParams?.pickUpStoreId)
          }
          // 1: 配送 2: 自提
          if (!shipmentType) {
            $cookies.set("shipmentType", commonParams?.shipmentType)
          }
          if (!saleType) {
            $cookies.set("saleType", commonParams?.saleType)
          }
          if (token) {
            // 用户信息不存在 或者 门店信息不存在
            if (!accountInfo) {
              accountInfo = await dispatch("getLoginInfo", req)
            }
            if (!storeId || !storeInfo) {
              // 配送模式 1
              if (commonParams.shipmentType == 1) {
                if (accountInfo?.address?.length) {
                  // 优先级: curSelAddress > default address > address first
                  defaultAddress =
                    accountInfo.address.find(item => item.priority == "Default") || accountInfo.address[0]
                  if (curSelAddress) {
                    if (accountInfo.address.find(item => item.id == curSelAddress.id)) {
                      defaultAddress = curSelAddress
                    }
                  }
                  storeInfo = await dispatch("getStoreInfo", {
                    defaultAddress
                  })
                  storeId = storeInfo.id
                }
              }
              // 目前是自提模式 2
            }
          } else {
            process.client && resetLocal()
            curSelAddress = ""
            accountInfo = null
            storeInfo = null
          }
          // 门店信息不存在 使用初始参数重置经纬度 兜底
          if (!storeId && commonParams && commonParams.deliveryLng) {
            $cookies.set("longitude", commonParams?.deliveryLng)
            $cookies.set("latitude", commonParams?.deliveryLat)
            $cookies.set("store", commonParams?.storeId)
          }
          // 设置门店、用户信息等数据
          commit("setStoreInfo", storeInfo)
          commit("setAccountInfo", accountInfo)
          commit("setIsServerInit", process.server)

          // 公共环境变量同步
          const result = await dispatch("getCommonParamsSet")

          // 缓存到本地
          // TODO 待commData不再使用，删除
          if (process.client) {
            storage.set("commData", result)
          }

          updateSelStore(this.$cookies)

          return result
        } catch (error) {
          Logger.error("加载初始数据失败", error)
        }
      },
      /**
       * 获取公共参数
       */
      async getCommonParams(store, { params = {}, req }) {
        const { commit, state } = store
        try {
          const { data: commonParams } = await getComm(
            {
              param: JSON.stringify(params)
            },
            {
              headers: getRequestHeaders({ req, store })
            }
          )
          // 设置初始默认值
          commonParams.pickUpStoreId = commonParams.pickUpStoreId || ""
          commonParams.shipmentType = commonParams.shipmentType || 2
          commonParams.saleType = commonParams.saleType || 50
          commit("setCommonParams", commonParams)
          return commonParams
        } catch (error) {
          Logger.error("获取公共参数失败", error)
          return null
        }
      },
      /**
       * 获取登录信息
       */
      async getLoginInfo(store, req) {
        const { isOnline } = getLoginStatus(this.$cookies)
        if (isOnline) {
          try {
            const { data } = await getAccountInfo(
              {},
              {
                headers: getRequestHeaders({ req, store })
              }
            )
            if (data) {
              storage.set("accountInfo", data, { useBase64: true })
            }
            return data
          } catch (error) {
            Logger.error("加载用户信息失败", error)
          }
        }
      },

      /**
       * 获取门店信息
       */
      async getStoreInfo(store, { defaultAddress = {} }) {
        try {
          console.log("getStoreInfo   -------")
          const { lng, lat } = defaultAddress
          const param = JSON.stringify({
            longitude: lng,
            latitude: lat
          })
          this.$cookies.set("longitude", lng)
          this.$cookies.set("latitude", lat)
          const { data } = await getStoreInfo({ param })
          if (data) {
            storage.set("storeInfo", data)
            this.$cookies.set("store", data.id)
          } else {
            // 解决门店信息获取不到，导致不断重复刷新
            const storeId = this.$cookies.get("store")
            if (storeId != -1) {
              resetComm(this.$cookies)
            }
            return
          }
          return data
        } catch (error) {
          Logger.error("加载门店信息失败", error)
        }
      }
    }
  })

export default store
